import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import template from './calendar.vue';
import apiService from '@/services/api.service';
import { Action } from '@/store';
import { readableDate } from '@/utilities';
import { nl, enUS } from 'date-fns/locale';
import { AdditionalDay, WorkingDays, Calendar } from '@/definitions';
import { isSameDay, isBefore } from 'date-fns';
import { Tab } from '..';

@Component({
  mixins: [template],
})
export default class SettingsCalendar extends Vue {
  @Prop() model!: Calendar;
  @Prop() tab!: Tab;
  newOffDay: string | null = null;

  @Watch("model", { deep: true })
  calendarChanged() {
    this.$emit("applyChange", this.tab, this.model);
  }

  get company() {
    return this.$Store.state.company.company;
  }

  get daysOff(): AdditionalDay[] {
    return this.model.additionalDays.sort((a, b) => {
      return isBefore(new Date(a.date), new Date(b.date)) ? -1 : 1
    });
  }

  get isValidDate(): boolean {
    return Boolean(this.newOffDay && !this.daysOff.find(d => isSameDay(new Date(this.newOffDay as string), new Date(d.date))));
  }

  get workWeek(): WorkingDays {
    return this.model.workingDays;
  }

  getReadableDate(ad: AdditionalDay): string {
    return readableDate(new Date(ad.date), this.$i18n.locale === 'nl' ? nl : enUS);
  }

  addOffDay() {
    if (this.isValidDate) {
      this.daysOff.push({ isWorking: false, date: this.newOffDay as string });
      this.newOffDay = null;
    }
  }

  saveChanges() {
    try {
      apiService.saveCompanyCalendar(this.company._id, this.company.calendar);
      this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.settings.save_success', type: 'success' });
      this.$emit("changesSaved", this.tab);
    } catch (e) {
      this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.settings.save_error', type: 'danger' });
    }
  }

  removeDay(i: number) {
    this.model.additionalDays.splice(i, 1);
  }
}